const CLUSTER_ITEMS_LIST_ID = 'cluster-items-list-id'
const CLUSTER_ITEMS_LIST_PANEL_ID = 'cluster-items-list-panel-id'

const REACH_END_MESSAGE_THRESHOLD = 15

export {
  CLUSTER_ITEMS_LIST_ID,
  CLUSTER_ITEMS_LIST_PANEL_ID,
  REACH_END_MESSAGE_THRESHOLD
}
